import { createSelector } from "reselect"
import { values } from "lodash"

import { selectChannels } from "selectors/references"
import { selectSections } from "selectors/section"

const selectCategories = state => state.categories

export default createSelector([selectCategories, selectChannels], (categories, channels) => {
  if (categories.error) {
    return {
      error: categories.error,
    }
  }

  if (categories.pending || !categories.sections || !channels.length) {
    return { pending: true }
  }

  const sections = selectSections(values(categories.sections), { channels })

  return {
    ...categories,
    getSections() {
      return sections
    },
  }
})
